import { render, staticRenderFns } from "./InstallPWA.vue?vue&type=template&id=4d707d5e&scoped=true"
import script from "./InstallPWA.vue?vue&type=script&lang=js"
export * from "./InstallPWA.vue?vue&type=script&lang=js"
import style0 from "./InstallPWA.vue?vue&type=style&index=0&id=4d707d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d707d5e",
  null
  
)

export default component.exports